<template>
  <div class="lh-homes imgs" style="background-image:url(img/bg1.jpg)">
  	<div style="display:none;">
  		<img src="img/c1.png" />
  		<img src="img/figure.png" />
  		<img src="img/c2.png" />
  		<img src="img/c3.png" />
  	</div>
    <div class="lh-logo1"><img src="img/logo-a.png" /><span>安全生产：{{logoText}}</span></div>
    <div class="lh-progress-bg" style="background-image:url(img/c1.png)"></div>
    <div class="lh-progress-renwu" data-path="progress1" @click="renwuHover?gotoNext($event):''">
    	<div class="icon" :style="'background-image:url('+renwu+')'"></div>
    	<div class="bj" style="background-image:url(img/c3.png)"></div>
    	<div class="jt"><img src="img/jt1.png" /></div>
    </div>
    <div class="lh-total"><img src="img/c5.png" /></div>
    <div class="lh-progress-xq"><img src="img/c2.png" /></div>
    <div class="lh-progress-shadow"></div>
    <Footer :footerData="footerData"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default{
	data(){
		return {
			footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:3,type:'culture'},
			logoText:'工伤——工伤处理流程',
			renwu:'img/figure.png',
			renwuHover:'',
			webs:false
		}
	},
	created(e){
		var that=this;
		that.openAnimate();
	},
	mounted(e){
      var that=this;
      if($('body').width()<=980){
      	that.webs=true;
      }
    },
	components:{
		Footer
	},
	methods:{
		openAnimate(e){
			var that=this;
			setTimeout(function(){
				$('.lh-progress-renwu').css({transform:'translateX(-13vh)',transition:'linear 3.5s'});
				$('.lh-progress-renwu .icon').css({'animation-play-state':'running'});
				$('.lh-progress-bg').css({transform:'translateX(-100vw)',transition:'linear 3.5s'});
				setTimeout(function(){
					var y='29vw';
					if(that.webs){
						y='34vw';
					}
					$('.lh-progress-xq').css({transform:'rotate(-15deg) translate(-50%,'+y+')',transition:'ease-in .45s'});
					setTimeout(function(){
						$('.lh-progress-renwu .icon').css({'animation-play-state':'paused'});
						$('.lh-progress-renwu .bj').css({opacity:1,'animation-play-state':'running'});
						setTimeout(function(){
							$('.lh-progress-renwu .bj').css({opacity:0});
							that.renwu='img/c4.png';
							$('.lh-progress-renwu').addClass('one').css({transition:'linear 0s'});
							$('.lh-homes').addClass('Max');
							setTimeout(function(){
								var y1='70vw';
								if(that.webs){
									y1='100vw';
								}
								$('.lh-progress-xq').css({transform:'translate(-50%,'+y1+') rotate(-45deg)'});
								$('.lh-progress-renwu .icon').css({'animation-play-state':'running'});
								setTimeout(function(){
									$('.lh-progress-shadow').addClass('on');
									setTimeout(function(){
										that.renwu='img/c6.png';
										$('.lh-progress-renwu .icon').css({'animation-play-state':'paused'});
										$('.lh-homes').removeClass('Max');
										$('.lh-total').addClass('on');
										setTimeout(function(){
											that.renwu='img/c7.png';
											$('.lh-progress-renwu').removeClass('one');
											$('.lh-progress-bg').css({transform:'translateX(-200vw)',transition:'linear 3.5s'});
											$('.lh-progress-renwu .icon').css({'animation-play-state':'running'});
											setTimeout(function(){
												that.renwu='img/c9.png';
												$('.lh-progress-renwu .icon').css({'animation-play-state':'paused'});
												$('.lh-progress-renwu').addClass('two').css({transition:'0s'});
												that.renwuHover="on";
											},3500);
										},2000);
									},500);
								},300);
							},1000);
						},700);
					},450);
				},3050);
			},1000);
		},
		gotoNext(e){
			var that=this,tag = $(e.currentTarget),path=$(e.currentTarget).data('path');
			that.$router.replace({ path: path});
		},
	}
}
</script>
